import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Spin } from 'antd';
import BidChanceListComponent from '../../components/bid-chances/BidChanceListComponent';
import { RootState } from '../../modules';
import { getBidChanceListAsync } from '../../modules/bid-chances';

interface BidChanceListContainerProps {
  enterpriseId: string;
}
function BidChanceListContainer({
  match,
  history,
}: RouteComponentProps<BidChanceListContainerProps>) {
  const { enterpriseId } = match.params;
  const { data, loading, error } = useSelector(
    (state: RootState) => state.bidChances.bidChances,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBidChanceListAsync.request({ enterpriseId }));
  }, [dispatch, enterpriseId]);

  const moveToBidChanceDetailPage = (bidChanceId: number) => {
    history.push(`bidChances/${bidChanceId}`);
  };

  return (
    <>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}
      {data && (
        <BidChanceListComponent
          bidChances={data}
          moveToBidChanceDetailPage={moveToBidChanceDetailPage}
        />
      )}
    </>
  );
}

export default BidChanceListContainer;
